import axiosInstance from '../../helpers/axiosInstance'

export default function precalcularService (inputs) {
    return axiosInstance.post('calculo/precalcular', inputs)
        .then(response => response.data)
        .catch(error => {
          throw error;
        });
}